import { NgModule } from '@angular/core';

// ----- Common -----
import { CommonModule } from '@angular/common';

// ----- Forms -----
import { FormsModule } from '@angular/forms';

// ----- Kendo-Grid Module -----
import { ExcelModule, GridModule } from '@progress/kendo-angular-grid';

import { EmployeeSetupComponent } from './employee-setup.component';

import { EmployeeSetupService } from '../../services/employee-setup.service';

import { ContractorSetupModule } from '../contractor-setup/contractor-setup.module'; 
import { DepartmentSetupModule } from '../department-setup/department-setup.module';

@NgModule({
  imports: [
    CommonModule, FormsModule, GridModule, ContractorSetupModule, ExcelModule,DepartmentSetupModule
  ],
  declarations: [
    EmployeeSetupComponent
  ],
  exports: [
    EmployeeSetupComponent
  ],
  providers: [
    EmployeeSetupService
  ]
})
export class EmployeeSetupModule { }
